import * as React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { FileType, ReviewSignStatus } from '@/interfaces';

interface DocumentationRowActionsProps {
	item: FileType;
	isReviewSign: boolean;
	isShowModal: boolean;
	reviewStatus: ReviewSignStatus;
	onClickModal: (record: FileType) => void;
}

export const DocumentationRowActions: React.FC<
	DocumentationRowActionsProps
> = ({ item, isReviewSign, isShowModal, reviewStatus, onClickModal }) => (
	<>
		{isReviewSign && (
			<div className="flex items-center gap-6 shrink-0">
				{!reviewStatus.isApproved && item.file_name === 'Retainer' && (
					<div className="flex items-center gap-2">
						<Icon src={Icons.close} className="!size-4" />
						<Typography type="regular-12" className="text-gray-35">
							{' '}
							Declined{' '}
						</Typography>
					</div>
				)}
				{reviewStatus.isApproved && reviewStatus.isSigned && (
					<div className="flex items-center gap-3">
						<Icon src={Icons.check} className="!size-4" />
						<Typography type="regular-12" className="text-gray-35">
							{' '}
							Signed{' '}
						</Typography>
					</div>
				)}

				<button
					type="button"
					className="rounded-full p-1 hover:bg-grey-5 shrink-0"
					onClick={() => {
						onClickModal(item);
					}}
				>
					<Image
						src={Icons.documentDownload}
						height={16}
						width={16}
						alt="download document"
						unoptimized
					/>
				</button>
			</div>
		)}

		{isShowModal && !isReviewSign && (
			<div className="flex items-center gap-6 shrink-0">
				<button
					type="button"
					className="rounded-full p-1 hover:bg-grey-5"
					onClick={() => {
						onClickModal(item);
					}}
				>
					<Icon
						src={Icons.eye}
						height={16}
						width={16}
						className="text-primary"
					/>
				</button>
			</div>
		)}

		{!isShowModal && !isReviewSign && item.file_path && (
			<Link
				href={item.file_path ?? ''}
				target="_blank"
				download={item.file_name}
				rel="noopener noreferrer"
				className="focus:outline-none flex-shrink-0 rounded-full p-1 hover:bg-grey-5"
			>
				<Image
					src={Icons.documentDownload}
					height={16}
					width={16}
					alt="download document"
					unoptimized
				/>
			</Link>
		)}
	</>
);
